export class VendedorApi {
    
    async pluck() {
        try {
            const response = await axios.get('/adm/vendedor/pluck');

            return response.data;
        } catch (error) {
            console.error('Error fetching sales:', error);

            throw error;
        }
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/api/VendedorApi.js